<p-toast position="top-center no-print"></p-toast>
<div class="w-full h-full flex justify-content-center align-content-center" [ngClass]="{ 'bg-agsquare screenHeight': internal == false}">
  <div class="w-full h-full flex justify-content-center align-content-center" *ngIf="showResetPassword">
    <div class="form-signin text-center flex justify-content-center align-content-center flex-wrap">
      <div class="text-900 text-3xl font-bold text-center">
        Reimposta password
      </div>
      <div class="w-full text-center flex flex-wrap">
        <label class="w-full text-900 font-medium text-center mt-5">
          Inserisci la tua Email
        </label>
        <input  id="username"
                placeholder="email@email.com"
                type="text"
                pInputText
                class="w-full"
                [disabled]="false"
                [(ngModel)]="passwordRequestModel.email">
      </div>
      <div class="w-full block mt-5">
        <label class="block text-900 font-medium">Password</label>
        <p-password [(ngModel)]="passwordRequestModel.oldpassword"
                    [toggleMask]="true"
                    styleClass="w-full"
                    [strongLabel]="'Forte'"
                    [mediumLabel]="'Medio'"
                    [weakLabel]="'Debole'"
                    [promptLabel]="'Inserisci una Password'"></p-password>
        <label class="block mt-4 text-900 font-medium">Conferma password</label>
        <p-password [(ngModel)]="passwordRequestModel.newpassword"
                    [toggleMask]="true"
                    styleClass="w-full"
                    [strongLabel]="'Forte'"
                    [mediumLabel]="'Medio'"
                    [weakLabel]="'Debole'"
                    [promptLabel]="'Inserisci una Password'"></p-password>
      </div>
      <div class="btnWidth flex justify-content-center mt-2">
          <button pButton pRipple label="Salva" icon="pi pi-user" class="w-full p-button-rounded" (click)="controllaPassword()"></button>
      </div>
    </div>
  </div>

  <div *ngIf="!showResetPassword" class="w-full h-full flex justify-content-center align-content-center" [ngClass]="{ 'screenHeight': internal == false}">
    <div class="h-full flex justify-content-center align-content-center" [ngClass]="{ 'screenHeight': internal == false}">
      <div class="mt-0 form-signin mb-4 h-full flex justify-content-center align-content-center" [ngClass]="{ 'screenHeight': internal == false}">
        <div class="text-center mb-4">
          <div class="flex flex-wrap h-full justify-content-center align-content-center " >
            <div class="w-full h-full flex flex-wrap justify-content-center align-content-center pr-0 pl-0">
              <div class="text-900 text-3xl font-bold text-center">
                Reimposta password
              </div>
              <div class="row-6 btnWidth flex flex-wrap align-content-center justify-content-center pr-0 pl-0" *ngIf="internal == false">
                <label class="text-900 font-medium mb-2 mt-4 py-1">
                  Inserisci la tua Email
                </label>
                <input  id="username"
                        placeholder="email@email.com"
                        type="text"
                        pInputText
                        class="text-center w-full "
                        [disabled]="false"
                        autocomplete="new-password"
                        [(ngModel)]="loginRequestModel.username">

              </div>
              <div class="w-full flex justify-content-center p-0">
                <div class="w-full justify-content-center block py-3 mx-2">
                  <button pButton pRipple label="Richiedi reset password" icon="pi pi-user" class="mt-2 btnWidth p-button-rounded" (click)="resetPassword()"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
